import { styled } from '@linaria/react';
import { fonts, semantic, space } from '../../theme/tokens';

export const Panel = styled.div``;

export const HeaderRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: ${space['space-300']};
`;

export const PillGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${space['space-200']};
  padding: ${space['space-400']} 0;
`;

export const FormSection = styled.div`
  padding-top: ${space['space-300']};
`;

export const GenderSection = styled.div`
  padding-top: ${space['space-400']};
`;

export const GenderError = styled.div`
  margin-top: ${space['space-200']};
`;

export const GenderLabel = styled.span`
  display: block;
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
  margin-bottom: ${space['space-100']};
`;
